import { useParams } from 'react-router';

import { Spinner } from '@change/ds-core-ui/Spinner';

import { stripHtmlTags } from '@change-corgi/core/html';

import { withPrefetchedData } from '#src/shared/prefetch';

import type { PolicyPagePrefetchedDataProps } from '#src/app/pages/legal/policy/pageContext';
import { PolicyPageContextProvider, prefetchPageContext } from '#src/app/pages/legal/policy/pageContext';
import { getTitle } from '#src/app/pages/legal/policy/shared/utils';
import { isLoaded } from '#src/app/shared/utils/async';

import { Layout } from '../layout';

import { PolicyErrorHandler } from './ErrorHandler';

export const Policy = withPrefetchedData(
	function Policy({ prefetchedData }: PolicyPagePrefetchedDataProps) {
		const { slug } = useParams();

		return (
			<PolicyPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PolicyErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</PolicyPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context.params.slug, context),
		pageTitle: ({ prefetchedData, i18n, fromTemplate }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			const { slug } = prefetchedData.pageData.pageData;
			return fromTemplate(getTitle({ i18n }, slug));
		},
		pageMetadata: ({ prefetchedData, i18n }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return {};
			}
			const { slug, excerpt } = prefetchedData.pageData.pageData;
			const title = getTitle({ i18n }, slug);
			const description = stripHtmlTags(excerpt).trim();
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				ogType: 'website',
				twitterCard: 'summary',
			};
		},
	},
);
